import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { IExotelManualCallResponse, IExotelManualCallResponseData } from "@/api_framework/api_modals/Exotel";
import { EXOTEL_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});
export const useAmeyoExotelManualCallAPI = () => {
  const [manualCallData, setManualCallData] = useState<IExotelManualCallResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IExotelManualCallResponseData | null = await axios
        .request({
          method: "POST",
          url: EXOTEL_APIS?.EXOTEL_MANUAL_CALL_INIT?.baseURL ?? "",
          data: { initiated_at: Math.floor(Date.now() / 1000) },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IExotelManualCallResponse>) => {
          if (res.data.success === true || res.data.status === 200 || res.data.status === true) {
            setManualCallData(res.data.data);
            return res.data.data;
          } else {
            setManualCallData(null);
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          setManualCallData(null);
          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { manualCallData, execute };
};
